module.exports = __webpack_public_path__ + "static/heroOlympo310-9b8cff8afb0f4dedebe67e1b56341622.png";